import { useUiTheme } from 'framework/uiTheme';
import { Button, ButtonProps } from '../../mui-builder/Button/Button';

interface SubmitButtonProps extends ButtonProps {
  isLoading?: boolean;
}

const SubmitButton = ({ isLoading = false, ...props }: SubmitButtonProps) => {
  const { Button: ThemedButton = Button } = useUiTheme();

  return isLoading ? (
    <ThemedButton data-testid="submit-btn" color="primary" type="button" disabled>
      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ marginRight: 1 }} />
      Submitting...
    </ThemedButton>
  ) : (
    <ThemedButton data-testid="submit-btn" color="primary" type="submit" {...props}>
      Submit
    </ThemedButton>
  );
};

export default SubmitButton;
